// extracted by mini-css-extract-plugin
module.exports = {"container":"OverflowLayout_container__De4uv","overflowLayout":"OverflowLayout_overflowLayout__V5S1E"};